<template>
  <div class="car-display">
    <div class="row">
      <div class="col-md-6">
        <vue-form ref="form"
          :options="{ permalink: 'newLotRelocation', params: { driver: $route.params.carId } }">
        </vue-form>
      </div>
      <div class="col-sm-6">
        <div class="card card-primary">
          <div class="card-header">
            Conflicting Reservations
            <button type="button" @click="loadReservations()" class="btn btn-xs float-right btn-primary">
              <i class="fa fa-sync fa-fw"></i>
              Refresh
            </button>
          </div>
          <div class="card-body">
            <template v-for="reservation in carReservations">
              <div class="list-group-item" :key="reservation.uuid">
                <reservation-display :data="reservation"></reservation-display>
              </div>
            </template>
            <template v-if="carReservations.length === 0">
              <p class="alert alert-success">
                <strong>The car has no upcoming reservations and is ready to be moved to another Lot</strong>
              </p>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReservationDisplay from '@/components/displays/ReservationDisplay'
import VueForm from '@/components/Form'
import { mapGetters } from 'vuex'
import { LOAD_CAR_UPCOMING_RESERVATIONS } from '@/vuex/types'

export default {
  name: 'CarMoveDisplay',
  components: {
    VueForm,
    ReservationDisplay
  },
  async mounted () {
    await this.$store.dispatch(LOAD_CAR_UPCOMING_RESERVATIONS, this.$route.params.carId)
  },
  computed: {
    ...mapGetters([
      'carReservations'
    ])
  },
  methods: {
    async loadReservations () {
      await this.$store.dispatch(LOAD_CAR_UPCOMING_RESERVATIONS, this.$route.params.carId)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/displays/CarMoveDisplay.vue